import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Permite que o navegador envie cookies (como o de CSRF) em requisições cross-origin.
});

// Função para obter o valor de um cookie pelo nome. O Django envia o cookie 'csrftoken'.
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // O cookie começa com o nome que queremos?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  // Anexa o token CSRF em requisições que alteram dados (POST, PUT, DELETE, etc.)
  if (!['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(config.method.toUpperCase())) {
    config.headers['X-CSRFToken'] = getCookie('csrftoken');
  }
  return config;
}, (error) => Promise.reject(error));

axiosInstance.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;

  // CONDIÇÃO ATUALIZADA:
  // Agora, ele só tenta atualizar o token se o erro for 401 (Não autorizado)
  // E se a URL da requisição NÃO FOR a de login ou refresh.
  if (error.response?.status === 401 && !originalRequest._retry && originalRequest.url !== '/api/token/' && originalRequest.url !== '/api/token/refresh/') {
    originalRequest._retry = true;
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      try {
        const res = await axios.post(`${API_URL}/api/token/refresh/`, { refresh: refreshToken });
        localStorage.setItem('accessToken', res.data.access);
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = '/'; // Redireciona se o refresh token falhar
        return Promise.reject(refreshError);
      }
    } else {
      localStorage.clear();
      window.location.href = '/'; // Redireciona se não houver refresh token
    }
  }

  // Para todos os outros erros (incluindo o erro 400 do login), ele apenas rejeita a promise,
  // permitindo que o catch local (na página de login) lide com a exibição da mensagem de erro.
  return Promise.reject(error);
});

axiosInstance.put = (url, data, config) => axiosInstance({ method: 'put', url, data, ...config });

export default axiosInstance;